<template>
  <div id="app">
    <gknav />
    <router-view class="cont" />
    <gkfooter />
  </div>
</template>
<script>
import gknav from '@/components/common/gknav.vue'
import gkfooter from '@/components/common/gkfooter.vue'
export default {
  components: {
    gknav,
    gkfooter,
  },
}
</script>
<style lang="scss">
// body * {
//   -webkit-filter: grayscale(100%); /* webkit */
//   -moz-filter: grayscale(100%); /*firefox*/
//   -ms-filter: grayscale(100%); /*ie9*/
//   -o-filter: grayscale(100%); /*opera*/
//   filter: grayscale(100%);
//   filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
//   filter: gray; /*ie9- */
// }
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.marginT60 {
  margin-top: 60px;
}
.marginT30 {
  margin-top: 30px;
}
.marginT40 {
  margin-top: 40px;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.clear::before {
  content: '';
  display: block;
  clear: both;
}
</style>
